import { Skeleton } from '../../../../modules/design-system';

const HEIGHT_CLASSES =
  'h-[clamp(234px,62vw,320px)] ' +
  '@[600px]:h-[clamp(300px,40vw,380px)] ' +
  '@[900px]:h-[clamp(340px,34vw,400px)] ' +
  '@[1200px]:h-[clamp(380px,30vw,460px)]';

/**
 * Loading placeholder for HeroSection — same outer footprint and
 * pack-shaped silhouette as the real hero so the layout doesn't shift
 * when the offer arrives.
 */
export function HeroSkeleton() {
  return (
    <div className="relative flex h-full min-h-82 w-full items-center justify-center overflow-hidden">
      <Skeleton
        className={
          'aspect-[4/5] rounded-[28px] bg-white/10 ' + HEIGHT_CLASSES
        }
      />
    </div>
  );
}
